import reducer from './reducer'

export { moduleName } from './constants'
export default reducer
